import React, { useState } from 'react';
import TopBar from './TopBar';
import Sidebar from './Sidebar';

const STORAGE_KEY = 'sidebar_open';
// Full-width mode lifts every page's width cap (see index.css).
const FULL_WIDTH_KEY = 'layout_full_width';

export default function AppLayout({ children }) {
  const [open, setOpen] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) !== 'false'; } catch { return true; }
  });

  const toggle = () => setOpen(o => {
    const next = !o;
    try { localStorage.setItem(STORAGE_KEY, String(next)); } catch {}
    return next;
  });

  const [fullWidth, setFullWidth] = useState(() => {
    try { return localStorage.getItem(FULL_WIDTH_KEY) === 'true'; } catch { return false; }
  });

  const toggleFullWidth = () => {
    const next = !fullWidth;
    setFullWidth(next);
    try { localStorage.setItem(FULL_WIDTH_KEY, String(next)); } catch {}
  };

  return (
    <div className="flex min-h-screen bg-surface">
      <Sidebar open={open} onToggle={toggle} />
      <div className="flex flex-1 flex-col min-w-0 transition-all duration-200" style={{ marginLeft: open ? 240 : 56 }}>
        <TopBar fullWidth={fullWidth} onToggleFullWidth={toggleFullWidth} />
        <main className="flex-1 p-6" data-full-width={fullWidth}>
          {children}
        </main>
      </div>
    </div>
  );
}
